<template>
	<div style="background-color: #FFFFFF;">
		<navTitle><div class="pageTitle">设置</div></navTitle>
		
		<div class="logo">
			<img src="@/static/images/logo.png" alt="">
		</div>
		<div class="title">{{commonConfig.association_name}}</div>
		<div class="version">v {{commonConfig.version}}</div>
		<div class="lineList">
			<router-link :to="{'name': 'setting_pages', 'query': {'name': 'privacy'}}">
			<div class="line flex flex-align-center flex-jus-between">
				<div>关于隐私</div>
				<img src="@/static/images/icon-arrowRight.png" alt="">
			</div>
			</router-link>
			
			<router-link :to="{'name': 'setting_pages', 'query': {'name': 'system'}}">
				<div class="line flex flex-align-center flex-jus-between">
					<div>关于该系统</div>
					<img src="@/static/images/icon-arrowRight.png" alt="">
				</div>
			</router-link>
			
			
			
		</div>
	</div>
</template>

<script>
	/* eslint-disable */
	import {mapState} from 'vuex'
	export default {
		watch: {
		},
		data() {
			return{
				version: '',
				association_name: ''
			}
		},
		computed: {
			...mapState(['commonConfig']),
		},
		created() {

		},
		mounted() {
			this.$wx.ready(() => {
				this.$wx.updateAppMessageShareData({
					title: '福建省民族管弦乐学会',
					desc: '设置',
					link: location.href,
					imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
				})
				this.$wx.updateTimelineShareData({
					title: '福建省民族管弦乐学会',
					link: location.href,
					imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
				})
			});
		},
		methods: {

		}
	}
</script>

<style scoped lang="stylus">
.logo
	width 160px
	height 160px
	margin 86px auto 24px auto
	img
		width 100%
		height 100%
.title
	width 100%
	text-align center
	font-size: 32px;
	font-weight: bold;
	color: #000000;
.version
	width 100%
	text-align center
	font-size: 28px;
	color: #232220;
	margin-top 12px
.lineList
	padding 0 30px
	.line
		padding 36px 0
		border-bottom 2px solid #E6E6E6;
		font-size: 28px;
		color: #232220;
		img
			width 12px
			height 24px
</style>
